import './search-dropdown.scss'

export class SearchDropdown {
  constructor() {
    this.init();
  }

  init = () => {
    if ('IntersectionObserver' in window) {
      this.stickyObserver();
    }

    this.openSearchDropdown();
  };

  stickyObserver = () => {
    const stickyEls = document.querySelectorAll('[data-sticky]');

    const options = {
      rootMargin: `100px 0px 0px 0px`,
      threshold: 0
    }

    const onIntersect = (entries) => {
      entries.forEach(entry => {
        const intersecting = entry.isIntersecting
        const isSticky = intersecting ? 'false' : 'true';
        stickyEls.forEach(stickyEl => {
          stickyEl.dataset.sticky = isSticky;
        })

      })
    }

    const observer = new IntersectionObserver(onIntersect, options);

    observer.observe(document.getElementById('main-wrapper'));
  }

  openSearchPanel = () => {
    const searchDropdownContent = document.querySelector('.search-dropdown-content');
    const searchOverlay = document.querySelector('#search-selector-overlay');
    
    searchDropdownContent.classList.add('open');
    document.body.classList.add('prevent-scroll');
    searchOverlay.style.display = 'block';
    
    let element = document.querySelector('#block__searchheaderblock .js-form-submit');
    let new_element = element.cloneNode(true);
    element.parentNode.replaceChild(new_element, element);
  }

  closeSearchPanel = () => {
    const searchDropdownContent = document.querySelector('.search-dropdown-content');
    const searchOverlay = document.querySelector('#search-selector-overlay');
    
    searchDropdownContent.classList.remove('open');
    document.body.classList.remove('prevent-scroll');
    searchOverlay.style.display = 'none';
  }

  isSearchPanelOpen = () => {
    const searchDropdownContent = document.querySelector('.search-dropdown-content');
    return searchDropdownContent && searchDropdownContent.classList.contains('open');
  }

  openSearchDropdown = () => {
    const searchButtons = document.querySelectorAll('.search-toggle');
    const searchOverlay = document.querySelector('#search-selector-overlay');
    
    setTimeout(() => {
      searchButtons.forEach(btn => {
        btn.addEventListener('click', (evt) => {
          evt.preventDefault();
          
          if (this.isSearchPanelOpen()) {
            this.closeSearchPanel();
          } else {
            this.openSearchPanel();
          }
        });
      });

      // Close search panel when clicking on overlay (outside panel)
      if (searchOverlay) {
        searchOverlay.addEventListener('click', (event) => {
          event.preventDefault();
          this.closeSearchPanel();
        });
      }
    }, 1000);

  }

  handleSearchDropdownIconKeyboardEvents(_e) {
    if (_e.key == 13) { // check if Enter key was pressed
      document.getElementById('views-exposed-form-sollio-search-search-block').submit();
    }
  }

  handleSearchDropdownIconClickEvents(_e) {
    document.getElementById('views-exposed-form-sollio-search-search-block').submit();
  }

}
window.addEventListener('DOMContentLoaded', () => {
  const searchDropdown = new SearchDropdown();
});



